import Web3 from 'web3';
import abi_token from './abi_token.json';
import abi_ERC4626 from './abi_ERC4626.json';
import abi_NFT from './abi_NFT.json';
import abi_oracle from './abi_oracle.json';
import abi_orchestrator from './abi_orchestrator.json';
import Swal from 'sweetalert2';
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

export const CMTY_ABI = abi_token;
export const CMTYV_ABI = abi_ERC4626;
export const CMTYNFT_ABI = abi_NFT;
export const ORACLE_ABI = abi_oracle;
export const ORCHESTRATOR_ABI = abi_orchestrator;

export const GAS_MULTIPLIER = 2; // Gas buffer multiplier (2 = 100% buffer)
export const PRICE_MULTIPLIER = 4; // Gas price multiplier for fast inclusion

let isProduction = true;
export let networks;
export let providerOptions;
export let networkConfig;

export let CMTY_TokenContractAddress;
// export let CMTYv_TokenContractAddress;
export let NFT_ContractAddress;
export let ORACLE_ContractAddress;
export let ORCHESTRATOR_ContractAddress;
export let CMTY_API_KEY =  'cmty_sk_9a7f2e4b8c1d6f3e5a9b2c7d4e8f1a6b3c5d7e9f2a4b6c8d1e3f5a7b9c2d4e6f8';

export let PINATA_API_KEY = process.env.VUE_APP_PINATA_API_KEY;
export let PINATA_SECRET_KEY = process.env.VUE_APP_PINATA_SECRET_KEY;

export let API= {
    // IPFS
    pinFileToIPFS:'https://api.pinata.cloud/pinning/pinFileToIPFS',
    pinJSONToIPFS:'https://api.pinata.cloud/pinning/pinJSONToIPFS',
}

if(isProduction){
    networks = [{name: 'PulseChain', chainId: 369}];
    providerOptions = {
        // walletconnect option removed - only MetaMask will be shown
    };
    networkConfig = {
        chainIdHex: '0x171',
        chainName: 'PulseChain',
        nativeCurrency: {
            name: 'PLS',
            symbol: 'PLS',
            decimals: 18
        },
        rpcUrls: ['https://rpc.pulsechain.com'],
        blockExplorerUrls: ['https://ipfs.scan.pulsechain.com']
    };

    CMTY_TokenContractAddress = '0x4f67b2b437a8f555278301F48Ea70a45bE1D5077';
    NFT_ContractAddress = '0x56f8d8D31B3eb3D2aD2E44Bd74B7682D6F26e6EA';
    ORACLE_ContractAddress = '0x850F70CB6d812387F386e528B5377AD5a156F4ad';
    ORCHESTRATOR_ContractAddress = '0x479a3e054cD894Bd72A4C5c1B42243AD59cee99a';
}else{

    networks = [{name: 'PulseChain Testnet v4', chainId: 943}];
    providerOptions = {
        // walletconnect option removed - only MetaMask will be shown
    };
    networkConfig = {
        chainIdHex: '0x3af',
        chainName: 'PulseChain Testnet v4',
        nativeCurrency: {
            name: 'tPLS',
            symbol: 'tPLS',
            decimals: 18
        },
        rpcUrls: ['https://rpc.v4.testnet.pulsechain.com'],
        blockExplorerUrls: ['https://scan.v4.testnet.pulsechain.com']
    };

    CMTY_TokenContractAddress = '0xDa14B8d3f5DD1a8259c5e6A3e9C6a546F8bF41Df';
    // CMTYv_TokenContractAddress = '0x182b93B54d709FDEBfC5503FF6089CbDB5aAD814';
    NFT_ContractAddress = '0x9436828D0F13b0c8AC3eB6bE1ec5983C33E8d0c1';
    ORACLE_ContractAddress = '0xd37F3d6db33902296085bF853fAB5E8DE67588f3';
    ORCHESTRATOR_ContractAddress = '0x9EEA49d2a4550F5eE27e9B6B726A10DF48314Cc3';

}

export const web3Modal = new Web3Modal({
    cacheProvider: true, // optional
    providerOptions, // required
    // disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
});

export const toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});

export function subtractDecimals (amount, decimals) {
    // Handle BigInt values by converting to string first
    if (typeof amount === 'bigint') {
        // Convert to string and then to number for display purposes
        return Number(amount) / (10 ** decimals);
    }
    return amount / (10 ** decimals);
}
export function addDecimals (amount, decimals) {
    return amount * 10 ** decimals;
}

export async function reconnect(){
    const isConnected = JSON.parse(localStorage.getItem("isConnected"));
    if(isConnected == null){
        web3Modal.clearCachedProvider();
    }
    const provider = await web3Modal.connect();

    const web3 = new Web3(provider);
    window.myWeb3 = web3;
    localStorage.setItem('isConnected', true);

    const chainId = await window.myWeb3.eth.net.getId();
    if (chainId !== networks[0].chainId) {
        Swal.fire({
            title: 'Opps!',
            text: 'Please switch to ' + networks[0].name,
            icon: 'info',
            showCloseButton: false,
            confirmButtonText: 'Switch',
            allowOutsideClick: false
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                switchNet();
            }
        });
    }

    // Subscribe to chainId change
    provider.on("chainChanged", (chainId) => {
        if (parseInt(chainId) !== networks[0].chainId) {
            Swal.fire({
                title: 'Opps!',
                text: 'Please switch to ' + networks[0].name,
                icon: 'info',
                showCloseButton: false,
                confirmButtonText: 'Switch',
                allowOutsideClick: false
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    switchNet();
                }
            });

        } else {
            window.location.reload();
        }
    });

    provider.on("accountsChanged", (accounts) => {
        window.location.reload();
    });
}

// switchNet - dynamically uses network configuration
async function switchNet(){
    await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          "chainId": networkConfig.chainIdHex,
          "chainName": networkConfig.chainName,
          "nativeCurrency": networkConfig.nativeCurrency,
          "rpcUrls": networkConfig.rpcUrls,
          "blockExplorerUrls": networkConfig.blockExplorerUrls
        }]
    });
    
    setTimeout(function() {
        window.location.reload();
    }, 1000);
}

export async function tokenContractInstance () {
    return new window.myWeb3.eth.Contract(abi_token, CMTY_TokenContractAddress);
}

/*
export async function vaultContractInstance () {
    return new window.myWeb3.eth.Contract(abi_ERC4626, CMTYv_TokenContractAddress);
}
*/

export async function NFTContractInstance () {
    return new window.myWeb3.eth.Contract(CMTYNFT_ABI, NFT_ContractAddress);
}

export async function OracleContractInstance () {
    return new window.myWeb3.eth.Contract(abi_oracle, ORACLE_ContractAddress);
}

export async function OrchestratorContractInstance () {
    return new window.myWeb3.eth.Contract(abi_orchestrator, ORCHESTRATOR_ContractAddress);
}

export function getCoinbase () {
    // if .then return null is not connected to metamask
    return window.myWeb3.eth.getCoinbase();
}

export function convertTimestampToDateTime(timestamp){
    var a = new Date(timestamp * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    // var months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    var year = String(a.getFullYear()).substr(2,3);
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes() < 10 ? '0' + a.getMinutes() : a.getMinutes(); 
    // var sec = a.getSeconds() < 10 ? '0' + a.getSeconds() : a.getSeconds();
    // var time = month + ' ' + date + ' ' + year + ' / ' + hour + ':' + min + ':' + sec ;
    // console.log(year);
    var time = month + ' ' + date + ' ' + hour + ':' + min;
    return time;
}

export function getContractData(contractName) {
    // Devuelve la dirección y el ABI del contrato basado en su nombre
    switch(contractName) {
        case 'CMTY':
            return {
                address: CMTY_TokenContractAddress,
                abi: CMTY_ABI
            };
        /*
        case 'CMTYVault':
            return {
                address: CMTYv_TokenContractAddress,
                abi: CMTYV_ABI
            };
        */
        case 'CMTYNFT':
            return {
                address: NFT_ContractAddress,
                abi: CMTYNFT_ABI
            };
        case 'Oracle':
            return {
                address: ORACLE_ContractAddress,
                abi: ORACLE_ABI
            };
        case 'Orchestrator':
            return {
                address: ORCHESTRATOR_ContractAddress,
                abi: ORCHESTRATOR_ABI
            };
        default:
            throw new Error(`Contrato ${contractName} no encontrado`);
    }
}

export async function getWeb3() {
    if (window.myWeb3) {
        return window.myWeb3;
    }
    
    // Si no hay una instancia de web3, intentar reconectar
    await reconnect();
    return window.myWeb3;
}
